﻿/*
 * @class rlReasonWhy
 */

(function ($) {
   $.fn.rlReasonWhy = function () {

      /// GET BLOCK INSTANCE(s) UNIQUE ID(s)
      let uniqueID = document.querySelectorAll('.reasonwhycontainer .reasonwhyparent'),
          uniqueArray = [];
      for (let u = 0; u < uniqueID.length; u++) {
         uniqueArray.push(uniqueID[u].getAttribute('id'));
      }

      for (let b = 0; b < uniqueArray.length; b++) {

         //BLOCK VARIABLES
         const uniqueBlockID = '#' + uniqueArray[b];

         let  selectedButtonArray = [],
            selectedCopyArray = [],
            scrollTextAreaHeight = 0,
            buttonRemovedPreviousDataId = null, ///null = add button, string = removed buttons previous data id
            scrollToDoubleSpacing = document.querySelector(uniqueBlockID + ' .spacingDetector').scrollHeight,
            unselectedFirst = false;

         const uniqueGuid = document.querySelector(uniqueBlockID).dataset.uniqueid,
            reasonWhyCheckbox = document.querySelectorAll(uniqueBlockID + ' .section--itemcontainer .items .itemCheckbox'),
            reasonWhyLabel = document.querySelectorAll(uniqueBlockID + ' .section--itemcontainer .items .itemLabel'),
            reasonWhyLabelSpan = document.querySelectorAll(uniqueBlockID + ' .section--itemcontainer .items .itemLabel span'),
            reasonWhyCopys = document.querySelectorAll(uniqueBlockID + ' .section--itemcontainer .textareas .itemCopy'),
            reasonwhyTextArea = document.getElementById('reasonwhyTextArea-' + uniqueGuid),
            reasonwhyTextAreaState = document.getElementById('reasonwhyTextAreaState-' + uniqueGuid),
            utilityCopy = document.querySelectorAll(uniqueBlockID + ' .section--output .utilitybuttons .utilitycopy'),
            utilityUndo = document.querySelectorAll(uniqueBlockID + ' .section--output .utilitybuttons .utilityundo'),
            utilityClear = document.querySelectorAll(uniqueBlockID + ' .section--output .utilitybuttons .utilityclear'),
            copiedtoClipboard = document.querySelector(uniqueBlockID + ' .textareaContainer .copied'),
            copiedtoClipboardText = copiedtoClipboard.dataset.tooltiptext,
            spacingDetector = document.querySelector(uniqueBlockID + ' .spacingDetector');

         //EVENTS
         for (let i = 0; i < reasonWhyCheckbox.length; i++) {
            reasonWhyCheckbox[i].addEventListener("focusin", function () {
               reasonWhyLabel[i].classList.add('focus');
            });
            reasonWhyCheckbox[i].addEventListener("focusout", function () {
               reasonWhyLabel[i].classList.remove('focus');
            });
            reasonWhyCheckbox[i].addEventListener("change", function () {
               const dataID = reasonWhyCheckbox[i].dataset.id,
                     itemCopy = reasonWhyLabel[i].innerHTML;
                     textareaScrollHeight = reasonWhyCopys[i].scrollHeight,
                     indexID = selectedButtonArray.indexOf(dataID);

               if (selectedButtonArray[0] === dataID) {
                  unselectedFirst = true;
               }
               else {
                  unselectedFirst = false;
               }

               if (reasonWhyCheckbox[i].checked === true) {
                  reasonWhyLabel[i].classList.add('checked');
                  buttonRemovedPreviousDataId = null;
                  selectedButtonArray.push(dataID);
                  selectedCopyArray.push(textareaScrollHeight);
                  outputTextAreaAriaLabelState('addItem', itemCopy);

               }
               else {
                  reasonWhyLabel[i].classList.remove('checked');
                  buttonRemovedPreviousDataId = selectedButtonArray.indexOf(reasonWhyCheckbox[i].dataset.id) - 1;
                  buttonRemovedPreviousDataId = selectedButtonArray.length <= 1 ? null : selectedButtonArray[buttonRemovedPreviousDataId];
                  outputTextAreaAriaLabelState('removeItem', itemCopy);
                  selectedButtonArray.splice(indexID, 1);
                  selectedCopyArray.splice(indexID, 1);
               }

               if (selectedButtonArray.length > 0) {
                  addtoTextArea();
               }
               else {
                  scrollTextAreaHeight = 0;
                  reasonwhyTextArea.value = '';
                  scrolledTextArea();
               }
            });
         }

         //Utility BUTTONS
         for (let u = 0; u < utilityCopy.length; u++) {
            utilityCopy[u].addEventListener("click", function () {
               if (selectedButtonArray.length >= 1) {
                  const utilitytextareaLength = reasonwhyTextArea.value.length - 1;

                  if (utilityCopy[u].classList.contains('top')) {
                     copiedtoClipboard.classList.add('top');
                  }
                  else {
                     copiedtoClipboard.classList.remove('top');
                  }

                  reasonwhyTextArea.select();
                  reasonwhyTextArea.setSelectionRange(0, utilitytextareaLength);
                  document.execCommand('copy');
                  reasonwhyTextArea.setSelectionRange(0, 0);
                  utilityCopy[u].focus();

                  copiedtoClipboard.classList.add('show');
                  copiedtoClipboard.setAttribute('aria-hidden', 'false');
                  outputTextAreaAriaLabelState('copiedItem', this);

                  setTimeout(function () {
                     copiedtoClipboard.classList.remove('show');
                     copiedtoClipboard.setAttribute('aria-hidden', 'true');
                  }, 2000);
               }
            });
         }
         
         for (let u = 0; u < utilityUndo.length; u++) {
            utilityUndo[u].addEventListener("click", function () {
               if (selectedButtonArray.length >= 1) {
                  const lastinArrayLength = selectedButtonArray.length - 1,
                     lastinArrayId = selectedButtonArray[lastinArrayLength],
                     lastinnerHTML = document.querySelector('.itemLabel[data-id=' + lastinArrayId + ']').innerHTML;

                  buttonRemovedPreviousDataId = selectedButtonArray.length === 1 ? null : selectedButtonArray[selectedButtonArray.length - 2];
                  outputTextAreaAriaLabelState('removeItem', lastinnerHTML);
                  selectedButtonArray.pop();
                  selectedCopyArray.pop();
                  unselectedFirst = false;

                  for (let i = 0; i < reasonWhyCheckbox.length; i++) {
                     if (reasonWhyCheckbox[i].dataset.id === lastinArrayId) {
                        reasonWhyCheckbox[i].checked = false;
                        reasonWhyLabel[i].classList.remove('checked');
                     }
                  }

                  addtoTextArea();
               }
            });
         }
         
         for (let u = 0; u < utilityClear.length; u++) {
            utilityClear[u].addEventListener("click", function () {
               selectedButtonArray = [];
               selectedCopyArray = [];
               buttonRemovedPreviousDataId = null;
               unselectedFirst = false;

               reasonwhyTextArea.value = '';
               for (let i = 0; i < reasonWhyCheckbox.length; i++) {
                  reasonWhyCheckbox[i].checked = false;
                  reasonWhyLabel[i].classList.remove('checked');
               }

               scrolledTextArea();
               outputTextAreaAriaLabelState();
            });
         }
         
         inputmultiline();

         $(window).on('resize-end', function () {
            windowResizeChecker();
            inputmultiline();
         });

         //FUNCTIONS
         function addtoTextArea() {
            reasonwhyTextArea.value = '';
            reasonwhyTextArea.innerHTML = '';
            for (let a = 0; a < selectedButtonArray.length; a++) {
               for (let b = 0; b < reasonWhyCopys.length; b++) {
                  if (reasonWhyCopys[b].dataset.id === selectedButtonArray[a]) {
                     const thisItemCopy = reasonWhyCopys[b].value;
                     reasonwhyTextArea.value += thisItemCopy;
                  }
               }
            }
            scrolledTextArea();
         }
         function scrolledTextArea() {

            //Calc Scroll height from copy height array
            let scrollSum = 0;
            const groupCopyLength = selectedCopyArray.length;

            for (let i = 0; i < groupCopyLength; i += 1) {
               if ((i + 1) == (groupCopyLength) && buttonRemovedPreviousDataId === null) {
                  ///omit last in height array from calculation
               }
               else {
                  scrollSum += (selectedCopyArray[i] - scrollToDoubleSpacing);
               }
            }

            //find position if user removed item
            if (buttonRemovedPreviousDataId != null) {

               let scrolltolastIndex = selectedButtonArray.indexOf(buttonRemovedPreviousDataId) - 1;
               scrolltolastRemoved = selectedCopyArray[scrolltolastIndex],
               indexScrollStart = 0,
               indexScrollEnd = scrolltolastIndex;

               scrollSum = 0;
               if (scrolltolastIndex != -1) {
                  for (let i = indexScrollStart; i <= indexScrollEnd; i++) {
                     scrollSum += (selectedCopyArray[i] - scrollToDoubleSpacing);
                  }
               }
            }

            scrollTextAreaHeight = scrollSum;

            //Set Scroll Height
            if (selectedButtonArray.length <= 1 || unselectedFirst === true) {
               scrollinOutput(0);
            }
            else {
               scrollinOutput(scrollTextAreaHeight);
            }
         }
         function windowResizeChecker() {
            let restorescrollSum = 0;
            const groupCopyLength = selectedCopyArray.length;

            scrollToDoubleSpacing = spacingDetector.scrollHeight;
            selectedCopyArray = [];

            for (let a = 0; a < selectedButtonArray.length; a++) {
               for (let i = 0; i < reasonWhyCopys.length; i++) {
                  if (reasonWhyCopys[i].dataset.id === selectedButtonArray[a]) {
                     selectedCopyArray.push(reasonWhyCopys[i].scrollHeight);
                  }
               }
            }

            //Set Scroll Height
            if (selectedButtonArray.length <= 1) {
               scrollinOutput(0);
            }
            else {
               for (let i = 0; i < groupCopyLength; i += 1) {
                  if ((i + 1) == (groupCopyLength) && buttonRemovedPreviousDataId === null) {
                     ///omit last in height array from calculation
                  }
                  else {
                     restorescrollSum += (selectedCopyArray[i] - scrollToDoubleSpacing);
                  }
               }
               scrollinOutput(restorescrollSum);
            }
         }

         function scrollinOutput(distance) {
            $('#reasonwhyTextArea-' + uniqueGuid).animate({
               scrollTop: distance
            }, 300);
         }

         function switchdefaultState() {
            setTimeout(function () {
               reasonwhyTextAreaState.innerHTML = '';
            }, 1500);
         }

         function outputTextAreaAriaLabelState(e, item) {
            const timeOut = 250;
            switch (e) {
               case 'addItem':
                  setTimeout(function () {
                     reasonwhyTextAreaState.innerHTML = item + ' text added';
                     switchdefaultState();
                  }, timeOut);
                  break;
               case 'removeItem':
                  setTimeout(function () {
                     reasonwhyTextAreaState.innerHTML = item + ' text removed';
                     switchdefaultState();
                  }, timeOut);
                  break;
               case 'copiedItem':
                  reasonwhyTextAreaState.innerHTML = copiedtoClipboardText;
                  switchdefaultState();
                  break;
               default:
                  reasonwhyTextAreaState.innerHTML = '';
            }
         }

         function inputmultiline() {
            for (let e = 0; e < reasonWhyLabel.length; e++) {
               var square = 32;
               if (reasonWhyLabelSpan[e].clientHeight > square) {
                  reasonWhyLabelSpan[e].classList.add('multilines');
               }
               else {
                  reasonWhyLabel[e].classList.remove('multilines');
               }
            }
         }
      } ///END FOR LOOP
   }
}(jQuery));